export default __webpack_public_path__ + "static/media/Digital Keys.719b5bb8.svg";